import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import ajaxUser from '../../util/remote/ajaxUser';
import functions from '../../util/functions';

const NewProfilePage = () => {
  const [companyName, setCompanyName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [notify, setNotify] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const tokenInfo = functions.readUser();

  useEffect(()=>{
      if(!loading && notify){
          setTimeout(() => {
              setNotify(false);
          }, 5000);
      }
  }, [notify])

  if (!tokenInfo) {
    return <Navigate to="/login" />;
  }

  const handleConfirm = async(event) =>{
      event.preventDefault();
      setLoading(true);
      const server_response = await ajaxUser.createProfile({
        "title":companyName,
        "address":address,
        "phone_number":phoneNumber,
        "email":email,
        "company_type_id":companyType,
      });
      setLoading(false);
      setNotify(<div className='mb-3'><ActivityLoader /></div> )
      if(server_response.status === "OK"){
          setNotify(<Notification message={server_response.message} type='success'/>);
          setTimeout(() => {
            navigate('/switch')
            window.location.reload();
          }, 3000);
      }else{
          setNotify(<Notification message={server_response.message} type='danger'/>);
      }
  }

  return (
    <div className="body d-flex align-items-center min-vh-100">
      <div className="container">
        <div className="row justify-content-center text-white">
          <div className="col-md-8">
            <div className="card login-card">
              <div className="card-body p-4">
                <div className="text-center mb-3 mt-0">
                <img
                  src='/assets/img/brand/logo-light.png'
                  className="header-brand-img"
                  alt="logo"
                />
                <img
                  src='/assets/img/brand/logo-light.png'
                  className="header-brand-img theme-logos"
                  alt="logo"
                />
              </div>

              <p className="login-card-description">New Hotspot Business Profile</p>

                {notify}

                <form method="post" onSubmit={handleConfirm}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="companyName" className="">Business Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter business name"
                          value={companyName}
                          onChange={(e)=>setCompanyName(e.target.value)}
                          id="companyName"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="email" className="">Business Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter business email"
                          value={email}
                          onChange={(e)=>setEmail(e.target.value)}
                          id="email"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="phoneNumber" className="">Business Phone</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="+256 XXX XXX XXX"
                          value={phoneNumber}
                          onChange={(e) => {
                              const value = e.target.value.replace(/\D/g, '');
                              if (value.startsWith('0')) return;
                              const formatted = value
                                .replace(/^(\d{1,3})(\d{0,3})/, '+$1 $2')
                                .replace(/(\d{3})(\d{0,3})$/, '$1 $2')
                                .replace(/(\d{3}) (\d{3})(\d{0,3})$/, '$1 $2 $3');
                              setPhoneNumber(formatted.trim());
                            }}
                          maxLength={15}
                          id="phoneNumber"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group mb-3">
                        <label htmlFor="address" className="">Business Location</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter business address"
                          onChange={(e)=>setAddress(e.target.value)}
                          value={address}
                          id="address"
                          required
                        />
                      </div>
                    </div>
                  </div>

                

                  <button className="btn ripple btn-block login-btn w-100 mt-2" type="submit">
                    {loading ? "Please wait..." : "Create Profile"}
                  </button>
                </form>

                <p className="login-card-footer-text text-center mt-3 mb-0">
                  Already connected to an existing profile? <Link to="/switch" className="text-reset">Switch to Profile</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProfilePage;